import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import Vant from 'vant'
import { Lazyload } from 'vant'
import 'amfe-flexible'
import '@/scripts/vconsole'
import 'normalize.css/normalize.css'
import 'vant/lib/index.less'
import '@/assets/styles/vant.less'
import '@/assets/styles/fonts.css'
import '@/assets/less/common.less'
import '@vant/touch-emulator'
import { Toast } from 'vant'
import { PullRefresh } from 'vant'
import { Popover } from 'vant'
import { Dialog } from 'vant'
import { Picker } from 'vant'
import { Popup } from 'vant'
import Vconsole from 'vconsole'
if (process.env.VUE_APP_ENV !== 'prod') {
  const vConsole = new Vconsole()
  Vue.use(vConsole)
}
Vue.use(Vant)
Vue.use(Lazyload)
Vue.use(Popover)
Vue.use(PullRefresh)
Vue.use(Toast)
Vue.use(Dialog)
Vue.use(Picker)
Vue.use(Popup)
Vue.config.productionTip = false

const vue = new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
export default vue
